/**
 * Responsive variants for the product screenshots.
 *
 * The source PNGs are 1920px wide, but they render inside a `max-w-6xl`
 * (1152px) column with section padding — so at most ~1072px CSS on desktop, and
 * far smaller on mobile. Serving the single 1920px webp wasted ~130 KiB across
 * the page (flagged by Lighthouse). We emit a width ladder and let the browser
 * pick the smallest file that fits its viewport and DPR. Format/quality match
 * the existing vite-imagetools default (webp, q78).
 */
import showcaseMrrSrcSet from "@/assets/showcase-mrr-opportunities.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import funnelsSrcSet from "@/assets/funnels-screenshot.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import workflowsSrcSet from "@/assets/workflows-screenshot.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import metricsSrcSet from "@/assets/metrics-screenshot.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import customersSrcSet from "@/assets/customer-profile-real.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import eventsSrcSet from "@/assets/account-list-real.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import marketingSrcSet from "@/assets/revenue-signals.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import checkoutSrcSet from "@/assets/checkout-flow.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";
import revenueSrcSet from "@/assets/profile-revenue.png?w=640;960;1280;1920&format=webp&quality=78&as=srcset";

export {
  showcaseMrrSrcSet,
  funnelsSrcSet,
  workflowsSrcSet,
  metricsSrcSet,
  customersSrcSet,
  eventsSrcSet,
  marketingSrcSet,
  checkoutSrcSet,
  revenueSrcSet,
};

/**
 * Shared `sizes` for every screenshot: capped at the column width (~1072px)
 * once the viewport is wide enough, otherwise the viewport minus the section's
 * horizontal padding (px-6 = 1.5rem each side on mobile).
 */
export const SCREENSHOT_SIZES = "(min-width: 1152px) 1072px, calc(100vw - 3rem)";
